import React from "react";

import isEmpty from "lodash.isempty";
import { observer } from "mobx-react";
import { readableColor } from "polished";
import PropTypes from "prop-types";
import styled from "styled-components";

import { useStores } from "../../../contexts/StoreContext";
import Loader from "../Loader/Loader";

const StyledLabel = styled.label`
  min-width: 0;
`;

const StyledFilterWrapper = styled.div`
  background-color: ${({ theme }) => theme.primaryBackgroundColor};
  color: ${({ theme }) =>
    readableColor(
      theme.primaryBackgroundColor,
      theme.textColor,
      theme.negativeTextColor,
      false
    )};
`;

function RoleFilterSelect(props) {
  const { isLoading } = props;

  const { filtersStore, rolesStore } = useStores();
  const { roles } = rolesStore;

  const {
    vacancyCountByCategory,
    addCategoryToFilter,
    removeCategoryFromFilter,
    frontendFilters,
    searchResults,
  } = filtersStore;

  const handleChange = (e, vacancyCategory) => {
    const isSelected = e.target.checked;

    if (isSelected) {
      addCategoryToFilter(vacancyCategory);
    } else {
      removeCategoryFromFilter(vacancyCategory);
    }
  };

  return (
    <StyledFilterWrapper className="p-3">
      <h4>Role</h4>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {isEmpty(searchResults) && isEmpty(frontendFilters.categories) && (
            <span>Nothing to filter</span>
          )}
          {roles.map(({ roleName }) => {
            const isInputUsed =
              frontendFilters.categories.includes(roleName) ||
              vacancyCountByCategory[roleName] > 0;

            if (!isInputUsed) {
              return null;
            }

            return (
              <div key={roleName} className="d-flex align-items-center my-1">
                <input
                  checked={frontendFilters.categories.includes(roleName)}
                  id={roleName}
                  onChange={(e) => handleChange(e, roleName)}
                  type="checkbox"
                />
                <StyledLabel
                  className="ms-2 d-flex flex-grow-1"
                  htmlFor={roleName}
                >
                  <span className="text-truncate me-2">{roleName}</span>
                  <span className="ms-auto">
                    {vacancyCountByCategory[roleName] || 0}
                  </span>
                </StyledLabel>
              </div>
            );
          })}
        </>
      )}
    </StyledFilterWrapper>
  );
}
export default observer(RoleFilterSelect);

RoleFilterSelect.propTypes = {
  isLoading: PropTypes.bool,
};

RoleFilterSelect.defaultProps = {
  isLoading: false,
};
